export default __webpack_public_path__ + "static/media/services.a2d842c2.jpeg";